import React from 'react';
import DataTable from 'react-data-table-component';
import { Edit } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { H5 } from '../../../../AbstractElements';

const AccidentFileInfo = ({ accidentFiles = [], onSelectedRowsChange }) => {
    const navigate = useNavigate();

    const handleCallForm = (row) => {
        const callFormId = row.callForm?.[0];
        
        if (callFormId) {
            navigate(`/callform/${callFormId}`);
        } else {
            console.warn("Call form ID not found or structure unexpected in row:", row);
        }
    };

    const columns = [
        { name: 'Dosya Numarası', selector: row => row.fileNumber || '', sortable: true },
        { name: 'Dosya Durumu', selector: row => row.fileCaseStatus || '', sortable: true },
        { name: 'Plaka', selector: row => row.accident?.licensePlate?.licensePlateNumber || '', sortable: true },
        { name: 'Kaza Tarihi', selector: row => row.accident?.accidentDate ? new Date(row.accident.accidentDate).toLocaleDateString() : '', sortable: true },
        { name: 'Dosya Türü', selector: row => row.filesToBeWorked?.[0]?.fileType?.title || '', sortable: true },
        { name: 'Azil Durumu', selector: row => row.impeachmentStatus || '', sortable: true },
        { name: 'Çalışılan Tutar', selector: row => row.amountWorked || '', sortable: true },
        { name: "Başvuru Durumu", selector: row => row.applicationStatus || '', sortable: true },
        { name: 'Esas Numarası', selector: row => row.docketNumber || '', sortable: true },
        {
            name: 'Düzenle',
            cell: row => (
                <div className="btn btn-outline-warning d-flex align-items-center justify-content-center" onClick={() => handleCallForm(row)}>
                    <Edit size={18}/>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            right: true,
            button: true,
        },
    ];

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <H5>Kaza Dosyaları</H5>
            </div>
            {accidentFiles.length === 0 ? (
                <p>Müşteriye ait kaza dosyası bulunamadı.</p>
            ) : (
                <DataTable
                    columns={columns}
                    data={accidentFiles}
                    pagination
                    paginationPerPage={10}
                    sortable
                    onSelectedRowsChange={onSelectedRowsChange}
                    clearSelectedRows={false}
                />
            )}
        </>
    );
};

export default AccidentFileInfo;
